import type { EditOrganizationSaved } from "./EditOrganizationDrawer";

interface EditOrganizationOutcomeProps {
    saved: EditOrganizationSaved;
}

// What an accepted Edit Organization save did, on the client detail page. A
// client awaiting signup whose contact email changed was sent a new signup
// link (API #426, Q1 A1); when that email failed the edit still stands, and
// the failure is said as one, with the way out (Resend invitation).
export const EditOrganizationOutcome = ({
    saved,
}: EditOrganizationOutcomeProps) => {
    if (saved.invitationSent === false) {
        return (
            <p role="alert" className="text-error">
                Changes saved, but the email with the new signup link to{" "}
                {saved.email} didn&apos;t send. Use Resend invitation to send
                another link.
            </p>
        );
    }

    return (
        <p role="status" className="font-medium">
            {saved.invitationSent
                ? `Changes saved. A new signup link was sent to ${saved.email}, and the earlier link no longer works.`
                : "Changes saved."}
        </p>
    );
};
